<template>
  <div>
    <Drawer
      :title="supportModalTitle"
      v-model="supportModal"
      width="500"
      :mask-closable="false"
      @on-close="supportModalCancel">
      <div>
        <Form ref="supportForm" :model="supportForm" :label-width="115" :rules="supportRule">
          <FormItem label="服务商名称" prop="name">
            <Input v-model="supportForm.name" />
          </FormItem>
          <FormItem label="access Key Id" prop="access_key_id">
            <Input v-model="supportForm.access_key_id" />
          </FormItem>
          <FormItem label="Access Key Secret" prop="access_key_secret">
            <Input type="password" v-model="supportForm.access_key_secret" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="supportForm.type" style="width:100%">
              <Option v-for="item in allTypeData" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="账号(或者主机)" prop="username">
            <Input v-model="supportForm.username" />
          </FormItem>
          <FormItem label="区域">
            <Input v-model="supportForm.area" />
          </FormItem>
          <FormItem label="端口" prop="port">
            <Input v-model="supportForm.port" />
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input type="textarea" v-model="supportForm.remark" />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="supportSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="supportModal = false">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
    <Card>
      <Row>
        <Col>
          <div style="float: right; margin-bottom: 8px">
            <Button icon="md-refresh" @click="getSupportData(support.page)" style="margin-right: 8px"></Button>
            <Button
              @click="supportModal = true; supportModalTitle='添加服务商'"
              type="primary"
              v-show="isSupportAdd"
              icon="md-add">添加服务商</Button>
          </div>
        </Col>
      </Row>
      <Table
        border
        :loading="supportTableLoading"
        :data="support.data"
        :columns="support.columns" min-width="260">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page :total="support.count" :current="support.page" :page-size="support.size" @on-change="getSupportData"
                show-total show-sizer show-elevator transfer
                :page-size-opts="[10, 15, 30]"
                @on-page-size-change="pageSizeChange"></page>
        </div>
      </div>
    </Card>
    <Drawer title="修改记录" :closable="true" width="550" v-model="LogsModel">
      <Logs :logs="RevisionLogs" />
    </Drawer>
  </div>
</template>

<script>
import { getOpsCenterSupport, changeOpsCenterSupport, deleteOpsCenterSupport,
  getContentTypeId, getRevisionLogs } from '@/api/opscenter'
import Logs from './Logs'
export default {
  name: 'support-manage',
  components: {
    'Logs': Logs
  },
  data () {
    return {
      isSupportAdd: false,
      isSupportEdit: false,
      isSupportDelete: false,
      isSupportView: false,
      supportModal: false,
      supportTableLoading: false,
      supportModalTitle: '添加服务商',
      supportForm: {
        id: 0,
        name: '',
        access_key_id: '',
        access_key_secret: '',
        type: 1,
        remark: '',
        username: '',
        port: '',
        area: ''
      },
      supportRule: {
        name: { required: true, message: '服务商名称不能为空', trigger: 'blur' }
      },
      allTypeData: [
        { 'value': 1, 'label': '阿里云' },
        { 'value': 2, 'label': 'UCloud' },
        { 'value': 3, 'label': '亚马逊云' },
        { 'value': 4, 'label': '其它' },
        { 'value': 5, 'label': 'Godaddy' },
        { 'value': 6, 'label': '西部数码' },
        { 'value': 7, 'label': 'Dnspod' },
        { 'value': 8, 'label': '华为云' },
        { 'value': 9, 'label': '存储' }
      ],
      support: {
        data: [],
        columns: [
          {
            title: '服务商ID',
            key: 'id',
            align: 'center',
            minWidth: 90
          },
          {
            title: '服务商名称',
            key: 'name',
            align: 'center',
            minWidth: 100
          },
          {
            title: '账号',
            key: 'username',
            align: 'center',
            minWidth: 100
          },
          {
            title: 'Access Key ID',
            key: 'access_key_id',
            align: 'center',
            minWidth: 200
          },
          {
            title: '类型',
            key: 'type',
            align: 'center',
            minWidth: 90,
            render: (h, params) => {
              let typeChoices = {
                1: '阿里云',
                2: 'UCloud',
                3: '亚马逊云',
                4: '其它',
                5: 'Godaddy',
                6: '西部数码',
                7: 'Dnspod',
                8: '华为云',
                9: '存储'
              }
              if (params.row.type) {
                return h('div', typeChoices[params.row.type])
              } else {
                return ''
              }
            }
          },
          {
            title: '备注',
            key: 'remark',
            align: 'center',
            minWidth: 100
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.revisionLog(params.row.id)
                      this.LogsModel = true
                    }
                  }
                }, '日志'),
                h('Button', {
                  style: {
                    display: this.isSupportEdit ? 'inline-block' : 'none',
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.supportModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.supportDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      display: this.isSupportDelete ? 'inline-block' : 'none'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      contentTypeId: '',
      LogsModel: false,
      RevisionLogs: []
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getSupportData()
    getContentTypeId({ 'model_name': 'Support' }).then(res => {
      let result = res.data
      this.contentTypeId = result.content_type_id
    })
  },
  methods: {
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_support') > -1) {
        this.isSupportAdd = true
      } else {
        this.isSupportAdd = false
      }
      if (permissions.indexOf('change_support') > -1) {
        this.isSupportEdit = true
      } else {
        this.isSupportEdit = false
      }
      if (permissions.indexOf('delete_support') > -1) {
        this.isSupportDelete = true
      } else {
        this.isSupportDelete = false
      }
      if (permissions.indexOf('view_support') > -1) {
        this.isSupportView = true
      } else {
        this.isSupportView = false
      }
    },
    supportModalCancel () {
      this.supportFormReset()
      this.supportModal = false
    },
    supportFormReset () {
      this.supportForm.id = 0
      this.supportForm.name = ''
      this.supportForm.access_key_id = ''
      this.supportForm.access_key_secret = ''
      this.supportForm.type = 1
      this.supportForm.username = ''
      this.supportForm.area = ''
      this.supportForm.port = ''
      this.supportForm.remark = ''
    },
    supportSubmit () {
      this.$refs['supportForm'].validate((valid) => {
        if (valid) {
          changeOpsCenterSupport(this.supportForm, this.supportForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getSupportData(this.support.page)
            this.supportFormReset()
            this.supportModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getSupportData (value = 1) {
      this.support.page = value
      let params = {
        size: this.support.size,
        page: this.support.page
      }
      this.supportTableLoading = true
      getOpsCenterSupport(params).then(res => {
        this.support.data = res.data.results
        this.support.count = res.data.count
        this.supportTableLoading = false
      }).catch(res => {
        this.supportTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取服务商列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取服务商列表失败！服务器无响应'
          })
        }
      })
    },
    supportModifyOpen (row) {
      this.supportForm.id = row.id
      this.supportForm.name = row.name
      this.supportForm.access_key_id = row.access_key_id
      this.supportForm.access_key_secret = row.access_key_secret
      this.supportForm.type = row.type
      this.supportForm.remark = row.remark
      this.supportForm.username = row.username
      this.supportForm.area = row.area
      this.supportForm.port = row.port
      this.supportModalTitle = '编辑供应商：' + row.name
      this.supportModal = true
    },
    supportDelete (row) {
      deleteOpsCenterSupport(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getSupportData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },

    // 修改记录
    revisionLog (id) {
      let params = {
        object_id: id,
        content_type: this.contentTypeId
      }
      getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      })
    },
    pageSizeChange (size) {
      this.support.size = size
      this.getSupportData(this.support.page)
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
